import range from 'lodash/range';

/**
 * Calculates the pagination settings based on totalItems, currentPage, items
 * per page and max number of pages.
 * @param {Number} totalItems The total amount of items to paginate.
 * @param {Number} currentPage The current page of the pagination.
 * @param {Number} itemsPerPage The max amount of items to show per page.
 * @param {Number} maxPages The max amount of pages/number to show in the
 *  pagination.
 * @return {Array} An array composed by:
 *   - endPage: The last page to show in the pagination.
 *   - firstPageItem: The index of the first element of the current page.
 *   - lastPageItem: The index of the last element of the current page.
 *   - page: An array with the numbers of the pages to show
 *   - startPage: The first page to show in the pagination.
 *   - totalPages: Total amount of pages to show.
 */
export const paginate = (totalItems, currentPage, itemsPerPage, maxPages) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
  const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
  const firstPageItem = (currentPage - 1) * itemsPerPage + 1;
  const lastPageItem = Math.min(firstPageItem + itemsPerPage - 1, totalItems);
  let startPage = 1;
  let endPage = totalPages;

  if (totalPages > maxPages) {
    if (currentPage <= maxPagesBeforeCurrentPage) {
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPages + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  return {
    endPage,
    firstPageItem,
    lastPageItem,
    pages: range(startPage, endPage + 1),
    startPage,
    totalPages,
  };
};
